module.exports = __webpack_public_path__ + "img/field-hockey-stick-ball.4381ca18.svg";